"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _polished = require("polished");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var defaultState = {
  checkbox: (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n    "], ["\n    \n    "]))),
  label: (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n    "], ["\n    \n    "])))
};
var error = {
  checkbox: (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        && {\n            border-color: #FF0000;\n            \n            &:not(:checked) {\n                background-color: #FFF5F5;\n\n                &:before {\n                    background-color: #FFF5F5;\n                }\n\n                &:after {\n                    background-color: #FFF5F5;\n                }\n\n                &:hover {\n                    background-color: ", ";\n\n                    &:before {\n                        background-color: ", ";\n                    }\n\n                    &:after {\n                        background-color: ", ";\n                    }\n                }\n            }\n        }\n    "], ["\n        && {\n            border-color: #FF0000;\n            \n            &:not(:checked) {\n                background-color: #FFF5F5;\n\n                &:before {\n                    background-color: #FFF5F5;\n                }\n\n                &:after {\n                    background-color: #FFF5F5;\n                }\n\n                &:hover {\n                    background-color: ", ";\n\n                    &:before {\n                        background-color: ", ";\n                    }\n\n                    &:after {\n                        background-color: ", ";\n                    }\n                }\n            }\n        }\n    "])), (0, _polished.shade)(0.08, "#FFF5F5"), (0, _polished.shade)(0.08, "#FFF5F5"), (0, _polished.shade)(0.08, "#FFF5F5")),
  label: (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        color: #FF0000;\n    "], ["\n        color: #FF0000;\n    "])))
};
var states = {
  default: defaultState,
  error: error
};
var _default = states;
exports.default = _default;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;